export default "__VITE_ASSET__C3utnX1H__"